<template>
  <div>    
    <v-footer
      height="70px"
    >
      <v-flex
        fill-height
        primary
        lighten-2
        py-2
        text-xs-center
        white--text
        xs12
        v-text="footer"
      />
    </v-footer>
    <v-footer
      color="primary lighten-1"
      fixed
    >
      <v-layout
        justify-center
      >
        <v-breadcrumbs 
          :items="breadcrumbs"
          dark>
          <v-icon slot="divider">chevron_right</v-icon>
        </v-breadcrumbs>
      </v-layout>
    </v-footer>
  </div>

</template>

<script>
export default {
  computed: {
    links() {
      return this.$store.getters.getRoutes;
    },
    footer() {
      return this.$store.getters.getConfig.footer;
    },
    breadcrumbs() {
      let breadcrumbs = [
        {
          to: "/",
          text: "HOME",
          disabled: false
        }
      ];
      let path = "";
      this.$route.path.split("/").forEach(function(item) {
        if (item) {
          path += "/" + item;
          breadcrumbs.push({
            to: path,
            text: item.toUpperCase(),
            disabled: false,
            exact: true,
            class: "white--text"
          });
        }
      });
      return breadcrumbs;
    }
  }
};
</script>
